
import {
  Grid,
  Row,
  Col,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
}from 'react-bootstrap';

import{
  CheckPid,
}from '../utils';

import{
  PATH,
}from '../const';

import {
  Redirect
}from 'react-router-dom';

import {
  BodyBackground,
}from './';

import {COLOR} from '../const';

var Radium = require('radium');
var React = require('react');
var FontAwesome = require('react-fontawesome');

var bkImg = require('../img/icon_flat_white.svg');
var bkGradient = require("../img/Gradient_Home.png");

class Home extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      inputText: '',
      isPidValid: false,
      wasChecked: false,
      isLoading: false,
      pidEntered: '',
    }
  }

  onChange = (e) => {
    let fieldName = e.target.name;
    this.setState({
      [fieldName]: e.target.value,
    })
  }

  onSubmit = () => {
    this.setState({
      isLoading: true,
    })

    CheckPid(this.state.inputText)
      .then(response => {
        this.setState({
          wasChecked: true,
        })

        if (response){
          this.setState({
            isPidValid: true,
            isLoading: false,
            pidEntered: this.state.inputText,
          }, )
        }else{
          this.setState({
            isPidValid: false,
            isLoading: false,
            pidEntered: this.state.inputText,
          })
        }
      })
      .catch(error => {
        console.log(error);
      })
  }

  redirectToPid = () => {

    const {pidEntered, isPidValid, wasChecked, isLoading} = this.state;

    if (pidEntered && isPidValid && wasChecked && !isLoading){
      return(
        <Redirect push to={`${PATH.home}${pidEntered}`}/>
      )
    }else {
      return null;
    }
  }

  render() {
    return(
      <div>
        <BodyBackground img={bkGradient} />
        <Grid style={styles.container}>
          <Row>
            <Col xs={12} md={8} mdOffset={2}>
              <img
                src={bkImg}
                alt="spelling dojo logo"
                style={styles.logo}
              />
            </Col>
          </Row>
          <Row>
            <Col xs = {12} md={8} mdOffset={2} lg={6} lgOffset={3}>
              <PidInput
                onChange={this.onChange}
                onSubmit={this.onSubmit}
                isLoading={this.state.isLoading}
                wasChecked = {this.state.wasChecked}
                isPidValid = {this.state.isPidValid}
              />
            </Col>
          </Row>
        </Grid>
        {this.redirectToPid()}
      </div>
    )
  }
}

let PidInput = (props) => {

  const {wasChecked, isLoading, onSubmit, onChange, isPidValid} = props;

  let btnClss = "primary";
  btnClss = (wasChecked && !isPidValid) ? 'danger' : 'primary';

  return(
    <FormGroup
      style={styles.inputGroup}
    >
      <div style={styles.inputGroup.header}>
        <h2>Welcome</h2>
        <p style={styles.inputGroup.header.p}>
          Please enter the PID code, you can find it in the top right of the activity pack.
        </p>
      </div>
        <InputGroup style={styles.inputGroup.inputs}>
          <FormControl
            type="text"
            onChange={onChange}
            name="inputText"
          />
          <InputGroup.Button>
            <Button
              bsStyle={btnClss}
              onClick={onSubmit}
              >
              <FontAwesome
                name={(isLoading) ? "circle-o-notch" :"search"}
                inverse={true}
                spin={(isLoading) ? true :false}
                size={"lg"}
              />
            </Button>
          </InputGroup.Button>
        </InputGroup>
        {wasChecked && !isPidValid &&
          <p style={styles.inputGroup.helpText}>The pid is not valid.</p>
        }
      </FormGroup>
  )
}

const styles = {
  logo: {
    width : '100%',
    height : 'auto',
    maxHeight : '400px',

  },
  container: {
    marginTop : '2rem',
  },
  inputGroup : {
    padding: '3rem 1rem',
    marginTop: '2rem',
    color: COLOR.white,

    header: {
      textAlign : 'center',

      p: {
        textAlign : 'left',
        fontSize: '16px',
      }
    },
    inputs: {
      marginTop: '2rem',
    },
    helpText: {
      marginTop: '1rem',
    },
  },
}



Home = Radium(Home);

export default Radium(Home);



// WEBPACK FOOTER //
// ./src/comp/Home.js